/**
 * Static registry of country-flag SVG components per supported language.
 *
 * Tree-shaking: we statically import only the flags we ship today. Adding a
 * new auxiliary language = add the import + the registry entry.
 *
 * Default mapping rationale:
 *  - en  → US  (user's primary audience uses US English; configurable per-user)
 *  - pt  → BR  (Brazilian Portuguese is the primary aux language)
 *  - de  → DE  (German itself, for power users showing both directions)
 *  - es  → ES  (Spain Spanish is the most common default; configurable)
 *  - it  → IT
 *  - fr  → FR
 *
 * Users override the mapping in Settings → Languages (writes to user_settings).
 */
import { BR, DE, ES, FR, GB, IT, US, type FlagComponent } from 'country-flag-icons/react/3x2';

export const LANG_FLAGS: Record<string, FlagComponent> = {
  en: US,
  'en-gb': GB,
  pt: BR,
  de: DE,
  es: ES,
  it: IT,
  fr: FR,
};

export const LANG_NAMES: Record<string, string> = {
  en: 'English',
  'en-gb': 'English (UK)',
  pt: 'Portuguese (Brasil)',
  de: 'German',
  es: 'Spanish',
  it: 'Italian',
  fr: 'French',
};

/** Resolve a lang code to its flag component, or null if unsupported. */
export function getLangFlag(code: string): FlagComponent | null {
  return LANG_FLAGS[code] ?? null;
}
